// Split rules into rules and groups arrays
export function fromModel({ rules, ...otherProps }, propertyMapping = {}, andOrKey = 'condition') {
  return {
    condition: otherProps[andOrKey],
    rules: rules.filter((rule) => !rule.group).map(applyReversedPropertyMapping(propertyMapping)),
    groups: rules.filter((rule) => rule.group).map((rule) => fromModel(rule.group, propertyMapping, andOrKey))
  };
}

// Merge groups into list of rules
export function toModel({ condition, rules, groups }, propertyMapping = {}, andOrKey = 'condition') {
  return {
    [andOrKey]: condition,
    rules: rules
      .map(applyPropertyMapping(propertyMapping))
      .concat((groups || []).map((group) => ({ group: toModel(group, propertyMapping, andOrKey) })))
  };
}

// Rename rule property keys using property mapping
function applyReversedPropertyMapping(propertyMapping = {}) {
  return (rule) =>
    Object.keys(rule).reduce((acc, newKey) => {
      const i = Object.values(propertyMapping).indexOf(newKey);
      acc[i > -1 ? Object.keys(propertyMapping)[i] : newKey] = rule[newKey];
      return acc;
    }, {});
}

// Rename rule property keys using property mapping
function applyPropertyMapping(propertyMapping = {}) {
  return (rule) =>
    Object.keys(rule).reduce((acc, key) => {
      const newKey = propertyMapping[key] || key;
      acc[newKey] = rule[key];
      return acc;
    }, {});
}

/**
 * Replaces IS/IS NOT operator 'NULL' value with `IS NULL/IS NOT NULL`
 * @param {Object} group contains condition and rules
 */
export function fromConditionGroup(group) {
  return {
    condition: group.condition,
    rules: group.rules.map((rule) => {
      if (['IS NULL', 'IS NOT NULL'].includes(`${rule.operator} ${rule.value.toUpperCase()}`)) {
        return {
          ...rule,
          operator: `${rule.operator} ${rule.value.toUpperCase()}`,
          value: undefined
        };
      }
      return rule;
    }),
    groups: group.groups.map((conditionGroup) => fromConditionGroup(conditionGroup))
  };
}

/**
 * Replaces `IS NULL/IS NOT NULL` with IS/IS NOT operator 'NULL' value
 * @param {Object} group contains condition and rules
 */
export function toConditionGroup(group) {
  return {
    operator: group.operator,
    rules: group.rules.map((rule) => {
      if (['IS NULL', 'IS NOT NULL'].includes(rule.condition)) {
        return {
          ...rule,
          condition: rule.condition === 'IS NULL' ? 'IS' : 'IS NOT',
          data1: 'NULL'
        };
      } else if (rule.group) {
        return {
          group: toConditionGroup(rule.group)
        };
      }
      return rule;
    })
  };
}
